export class Empresa {
    nomEmpresa: string;
    nomAbreviado: string;
    fecMov: Date;
    nomGerente: string;
    codFormatoImpLibreta: string;
}
